import { configure } from 'instantsearch.js/es/widgets';
import { defaultCard } from '../../partials/algolia-cards/default-card';
import { SearchBox, Stats, Hits, CurrentRefinements, Pagination, RefinementList } from '../../src/js/algolia/widgets';
import StuurluiAlgolia from '../../src/js/algolia';

const APP_ID = strl_vars.algolia_app_id;
const API_KEY = strl_vars.algolia_api_key;

function hitsEmptyTemplate(results) {
	if (results.query === '') {
		return null;
	}
	return `<p class="text-h3 font-semibold" data-no-results>
				${strl_vars.no_hits}
			</p>`;
}

function hitsItemTemplate(hit, { html, components }) {
	return defaultCard(hit, html, components);
}

const algolia = new StuurluiAlgolia(APP_ID, API_KEY, overview_source_locations_vars['index_name']);

const taxonomies = [...document.querySelectorAll('[id^="refinement-"]')].map((taxonomy) =>
	taxonomy.getAttribute('id').replace('refinement-', '')
);

const initialFacets = overview_source_locations_vars['initial_facets'] || {};

algolia.addWidgets([
	configure({
		hitsPerPage: 8,
	}),
	[
		...taxonomies.map((taxonomy) =>
			RefinementList({
				taxonomy,
				container: `#mobile-refinement-${taxonomy}`,
				attribute: `tax_${taxonomy}.name`,
				showMoreLimit: 5,
				sortBy: ['name:asc'],
				initialItems: initialFacets[taxonomy] || [],
			})
		),
	],
	[
		...taxonomies.map((taxonomy) =>
			RefinementList({
				taxonomy,
				container: `#refinement-${taxonomy}`,
				attribute: `tax_${taxonomy}.name`,
				showMoreLimit: 5,
				sortBy: ['name:asc'],
				initialItems: initialFacets[taxonomy] || [],
			})
		),
	],
	SearchBox(),
	Pagination('#search-pagination'),
	Stats(),
	Hits(
		{
			empty: hitsEmptyTemplate,
			item: hitsItemTemplate,
		},
		'#hits',
		{
			list: 'list-none grid grid-cols-1 gap-auto',
		}
	),
	CurrentRefinements('#current-refinements', {
		label: 'hidden',
		category:
			'text-[13px] leading-7 px-2 rounded-sm border-1 border-secondary-140 hocus:text-white hocus:bg-secondary-140 cursor-pointer',
		list: 'inline-flex flex-wrap gap-1 mb-0 max-lg:justify-center',
		item: 'inline-flex flex-wrap gap-1',
		delete: 'ml-1',
	}),
]);

algolia.start();
